export enum ResultsReportView {
    RESULTS = 'results',
    ARCHIVES = 'archives',
}
